export enum IAMRoles {
  endCustomer = 'EK',
  maintainer = 'KuMA',
  viInt = 'ViInt',
  viExt = 'ViExt',
}
